import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { extractError } from "../lib/format";
import { Loader2, CreditCard } from "lucide-react";

const STATUS_LABEL = {
  paid: { label: "Paid", cls: "is-paid" },
  pending: { label: "Pending", cls: "" },
  failed: { label: "Failed", cls: "is-review-flagged" },
  expired: { label: "Expired", cls: "" },
};

function formatWhen(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
  } catch { return iso; }
}

export default function MyPayments() {
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [err, setErr] = useState("");

  useEffect(() => {
    let alive = true;
    api.get("/checkout/payments")
      .then(({ data }) => { if (alive) setItems(data.items || []); })
      .catch((e) => { if (alive) setErr(extractError(e, "Could not load payments.")); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);

  if (loading) return <div className="ftg-subs__empty" data-testid="pay-loading"><Loader2 size={18} className="ftg-spin" /> Loading payments…</div>;
  if (err) return <div className="ftg-subs__empty" data-testid="pay-error">{err}</div>;
  if (!items.length) return (
    <div className="ftg-subs__empty" data-testid="pay-empty">
      No payments yet. Head to the <a href="/#pricing" style={{ color: "var(--ftg-terra)" }}>pricing section</a> to unlock more terms.
    </div>
  );

  return (
    <div className="ftg-subs" data-testid="pay-list">
      {items.map((p) => {
        const badge = STATUS_LABEL[p.payment_status] || { label: p.payment_status, cls: "" };
        return (
          <div key={p.id} className="ftg-subs__row" data-testid={`pay-row-${p.id}`}>
            <div className="ftg-subs__row-info">
              <div className="ftg-subs__row-meta">
                <CreditCard size={12} style={{ verticalAlign: "-2px", marginRight: 4 }} />
                {formatWhen(p.created_at)}
              </div>
              <div className="ftg-subs__row-title" style={{ display: "block", cursor: "default" }}>{p.tier_code}</div>
              <p className="ftg-subs__row-feedback">£{Number(p.amount).toFixed(2)} · {p.currency?.toUpperCase()}</p>
            </div>
            <div className="ftg-subs__row-side">
              <span className={`ftg-adm__pill ${badge.cls}`} data-testid={`pay-status-${p.id}`}>{badge.label}</span>
              <span className="ftg-subs__row-count" style={{ fontFamily: "ui-monospace,SFMono-Regular,monospace" }}>{p.session_id.slice(-10)}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
